import {
  clienteAxiosOctagon,
  clienteAxiosSaaS,
  clienteAxiosSaasExternalConector,
} from "../axios";

import { capitalizarTexto, tratoClienteConcesionaria } from "../../utilities/utils";

export const getCiudades = () => {
  return new Promise((resolve, reject) => {
    try {
      //Hacemos la peticion a la api

      const respuesta = clienteAxiosOctagon({
        method: "get",
        url: "/octagon/ciudades/",
        headers: {
          Authorization: process.env.REACT_APP_OCTAGON_AUTH_TOKEN,
          Auth: "",
          bypass: true,
        },
      });

      resolve(respuesta);
    } catch (error) {
      //Si existe un error
      reject("Error en petición a API - Ciudades");
    }
  });
};

export const sendLead = (lead) => {
  return new Promise((resolve, reject) => {
    try {
      //Hacemos la peticion a la api

      const respuesta = clienteAxiosOctagon({
        method: "post",
        url: "https://leads.serviciosdigitalesvw.com.mx/nuevo",
        headers: {
          "Content-Type": "application/json",
          authentication_id:
            "Bearer " + process.env.REACT_APP_AUDI_NUEVO_SERVICIOS_DIGITALES_TOKEN,
        },
        data: lead,
      });

      resolve(respuesta);
    } catch (error) {
      //Si existe un error
      reject("Error en petición de lead serviciosdigitalesvw");
    }
  });
};

export const getAudicodeInfo = (audicode = "") => {
  return new Promise((resolve, reject) => {
    try {
      //Hacemos la peticion a la api

      const respuesta = clienteAxiosSaasExternalConector({
        method: "get",
        url: "audi/carstore/get/configuration/" + audicode,
      });

      resolve(respuesta);
    } catch (error) {
      //Si existe un error
      reject("Error en petición de configurador");
    }
  });
};

export const sendMailConfiguradorCliente = (stateData) => {
  const urlAvisoDePrivacidad =
    stateData.dealerUrls.length === 0
      ? process.env.REACT_APP_AVISO_PRIVACIDAD
      : stateData.dealerUrls[1];

  const tratoMailCliente = stateData.trato === "Sr" ? "Estimado" : "Estimada";

  return new Promise((resolve, reject) => {
    try {
      const respuesta = clienteAxiosSaaS({
        method: "post",
        url: "mail/raw",
        data: {
          source: `${process.env.REACT_APP_CONFIGURADOR_CORREO_PERSONAL} <${process.env.REACT_APP_CONFIGURADOR_CORREO_FROM}>`,
          subject: process.env.REACT_APP_CONFIGURADOR_ASUNTO,
          to: [stateData.correo.trim()],
          cc: [],
          bcc: process.env.REACT_APP_CORREO_BCC_ICDC.split(","),
          html:
            `
              <!doctypehtml><html xmlns=http://www.w3.org/1999/xhtml xmlns:o=urn:schemas-microsoft-com:office:office xmlns:v=urn:schemas-microsoft-com:vml><title></title><!--[if !mso]><!--><meta content="IE=edge"http-equiv=X-UA-Compatible><!--<![endif]--><meta content="text/html; charset=UTF-8"http-equiv=Content-Type><meta content="width=device-width,initial-scale=1"name=viewport><style>#outlook a{padding:0}body{margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}table,td{border-collapse:collapse;mso-table-lspace:0;mso-table-rspace:0}img{border:0;height:auto;line-height:100%;outline:0;text-decoration:none;-ms-interpolation-mode:bicubic}p{display:block;margin:13px 0}</style><!--[if mso]><noscript><xml><o:officedocumentsettings><o:allowpng><o:pixelsperinch>96</o:pixelsperinch></o:officedocumentsettings></xml></noscript><![endif]--><!--[if lte mso 11]><style>.mj-outlook-group-fix{width:100%!important}</style><![endif]--><style>@media only screen and (min-width:480px){.mj-column-per-100{width:100%!important;max-width:100%}}</style><style media="screen and (min-width:480px)">.moz-text-html .mj-column-per-100{width:100%!important;max-width:100%}</style><style>@media only screen and (max-width:480px){table.mj-full-width-mobile{width:100%!important}td.mj-full-width-mobile{width:auto!important}}</style><body style=word-spacing:normal><div><!--[if mso | IE]><table border=0 cellpadding=0 cellspacing=0 align=center style=width:600px width=600><tr><td style=line-height:0;font-size:0;mso-line-height-rule:exactly><![endif]--><div style="margin:0 auto;max-width:600px"><table border=0 cellpadding=0 cellspacing=0 role=presentation style=width:100% align=center><tr><td style="direction:ltr;font-size:0;padding:20px 0;text-align:center"><!--[if mso | IE]><table border=0 cellpadding=0 cellspacing=0 role=presentation><tr><td style=vertical-align:top;width:600px><![endif]--><div style=font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100% class="mj-column-per-100 mj-outlook-group-fix"><table border=0 cellpadding=0 cellspacing=0 role=presentation style=vertical-align:top width=100%><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=center><table border=0 cellpadding=0 cellspacing=0 role=presentation style=border-collapse:collapse;border-spacing:0><tr><td style=width:76px><img height=auto src=https://www.appsaudi.com.mx/resources/images/logo_audi.png style=border:0;display:block;outline:0;text-decoration:none;height:auto;width:100%;font-size:13px width=76></table><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=center><table border=0 cellpadding=0 cellspacing=0 role=presentation style=border-collapse:collapse;border-spacing:0><tr><td style=width:550px><img height=auto src=https://www.appsaudi.com.mx/resources/images/formsSalesforce/formulario-configurador-mail.jpg style=border:0;display:block;outline:0;text-decoration:none;height:auto;width:100%;font-size:13px width=550></table></table></div><!--[if mso | IE]><![endif]--></table></div><!--[if mso | IE]><![endif]--><!--[if mso | IE]><table border=0 cellpadding=0 cellspacing=0 align=center style=width:600px width=600><tr><td style=line-height:0;font-size:0;mso-line-height-rule:exactly><![endif]--><div style="margin:0 auto;max-width:600px"><table border=0 cellpadding=0 cellspacing=0 role=presentation style=width:100% align=center><tr><td style="direction:ltr;font-size:0;padding:20px 0;text-align:center"><!--[if mso | IE]><table border=0 cellpadding=0 cellspacing=0 role=presentation><tr><td style=vertical-align:top;width:600px><![endif]--><div style=font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100% class="mj-column-per-100 mj-outlook-group-fix"><table border=0 cellpadding=0 cellspacing=0 role=presentation style=vertical-align:top width=100%><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=left><div style=font-family:AudiType,sans-serif;font-size:17px;line-height:1;text-align:left;color:#000><strong>${tratoMailCliente} ${stateData.nombre} ${stateData.apellidoPaterno}</strong></div><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=left><div style=font-family:AudiType,sans-serif;font-size:16px;line-height:1;text-align:left;color:#000>Agradecemos tu interés en el modelo que has configurado, hemos recibido toda tu información:</div><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=left><div style=font-family:AudiType,sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#000>Modelo: ${stateData.modelinfo.carline.name}<br>Audi Code: ${stateData.ac}<br>Versión: ${stateData.modelinfo.model.name}<br>Color Exterior: ${stateData.modelinfo.exteriorColor.name}<br>Potencia: ${stateData.modelinfo.topSpeed.value} ${stateData.modelinfo.topSpeed.unit}<br>Transmisión: ${stateData.modelinfo.transmision.value}</div><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=left><div style=font-family:AudiType,sans-serif;font-size:16px;line-height:1;text-align:left;color:#000>Tus datos han sido canalizados a nuestro concesionario <strong>${capitalizarTexto(stateData.concesionario)}</strong>, a la brevedad uno de nuestros asesores se pondrá en contacto contigo para darte seguimiento a tu interés de compra.</div><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=left><div style=font-family:AudiType,sans-serif;font-size:16px;line-height:1;text-align:left;color:#000>Para tu comodidad y seguridad, te informamos que nos estaremos comunicando desde el número: <strong>222 179 1156</strong>, esto con la finalidad de dar seguimiento a tu solicitud y atenderte como lo mereces.</div><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=left><div style=font-family:AudiType,sans-serif;font-size:16px;line-height:1.2;text-align:left;color:#000><p>Atentamente:<br><strong>Audi de México</strong><p>Línea de atención a clientes:<br><strong>800 849 23 83</strong><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=left><div style=font-family:AudiType,sans-serif;font-size:20px;line-height:1;text-align:left;color:#000><strong>¡Gracias por tu preferencia!</strong></div></table></div><!--[if mso | IE]><![endif]--></table></div><!--[if mso | IE]><![endif]--><!--[if mso | IE]><table border=0 cellpadding=0 cellspacing=0 align=center style=width:600px width=600><tr><td style=line-height:0;font-size:0;mso-line-height-rule:exactly><![endif]--><div style="margin:0 auto;max-width:600px"><table border=0 cellpadding=0 cellspacing=0 role=presentation style=width:100% align=center><tr><td style="direction:ltr;font-size:0;padding:20px 0;text-align:center"><!--[if mso | IE]><table border=0 cellpadding=0 cellspacing=0 role=presentation><tr><td style=vertical-align:top;width:600px><![endif]--><div style=font-size:0;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100% class="mj-column-per-100 mj-outlook-group-fix"><table border=0 cellpadding=0 cellspacing=0 role=presentation style=vertical-align:top width=100%><tr><td style="font-size:0;padding:10px 25px;word-break:break-word"align=center><p style="border-top:solid 1px #757575;font-size:1px;margin:0 auto;width:100%"></p><!--[if mso | IE]><table border=0 cellpadding=0 cellspacing=0 role=presentation style="border-top:solid 1px #757575;font-size:1px;margin:0 auto;width:550px"align=center width=550px><tr><td style=height:0;line-height:0> </table><![endif]--><tr><td style="font-size:0;padding:10px 25px;padding-top:5px;padding-right:40px;padding-bottom:15px;padding-left:40px;word-break:break-word"align=left><div style=font-family:AudiType,sans-serif;font-size:12px;font-weight:400;line-height:1;text-align:left;color:#757575><p>Este mensaje se envió a <strong style=color:#000>${stateData.correo.trim()}</strong></p><a href=${urlAvisoDePrivacidad}>Política de Privacidad</a></div></table></div><!--[if mso | IE]><![endif]--></table></div><!--[if mso | IE]><![endif]--></div>
            `,
        },
      });
      resolve(respuesta);
    } catch (error) {
      //Si existe un error
      console.log("Error correo: ", error);
      reject("Error en petición a API - Correo Cliente");
    }
  });
};

export const sendMailConfiguradorConcesionaria = (stateData) => {
  const urlAvisoDePrivacidad =
    "https://www.audi.com.mx/mx/web/es.html#layer=/mx/web/es/tools/navigation/layer/legal.html";

  const permisoTransferenciaDatos = stateData.permisoTransferenciaDatos
    ? "Sí"
    : "No";

  const tratamiento = tratoClienteConcesionaria(stateData.trato);

  return new Promise((resolve, reject) => {
    try {
      const respuesta = clienteAxiosSaaS({
        method: "post",
        url: "mail/raw",
        data: {
          source: `${process.env.REACT_APP_CONFIGURADOR_CORREO_PERSONAL} <${process.env.REACT_APP_CONFIGURADOR_CORREO_FROM}>`,
          subject: process.env.REACT_APP_CONFIGURADOR_ASUNTO,
          to: [process.env.REACT_APP_CORREO_AUDI],
          cc: [],
          bcc: process.env.REACT_APP_CORREO_BCC_ICDC.split(","),
          html:
            `<!doctype html>
          <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
          
          <head>
            <title>
            </title>
            <!--[if !mso]><!-->
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <!--<![endif]-->
            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <style type="text/css">
              #outlook a {
                padding: 0;
              }
          
              body {
                margin: 0;
                padding: 0;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
              }
          
              table,
              td {
                border-collapse: collapse;
                mso-table-lspace: 0pt;
                mso-table-rspace: 0pt;
              }
          
              img {
                border: 0;
                height: auto;
                line-height: 100%;
                outline: none;
                text-decoration: none;
                -ms-interpolation-mode: bicubic;
              }
          
              p {
                display: block;
                margin: 13px 0;
              }
            </style>
            <!--[if mso]>
                  <noscript>
                  <xml>
                  <o:OfficeDocumentSettings>
                    <o:AllowPNG/>
                    <o:PixelsPerInch>96</o:PixelsPerInch>
                  </o:OfficeDocumentSettings>
                  </xml>
                  </noscript>
                  <![endif]-->
            <!--[if lte mso 11]>
                  <style type="text/css">
                    .mj-outlook-group-fix { width:100% !important; }
                  </style>
                  <![endif]-->
            <!--[if !mso]><!-->
            <link href="https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700" rel="stylesheet" type="text/css">
            <style type="text/css">
              @import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);
            </style>
            <!--<![endif]-->
            <style type="text/css">
              @media only screen and (min-width:480px) {
                .mj-column-per-100 {
                  width: 100% !important;
                  max-width: 100%;
                }
              }
            </style>
            <style media="screen and (min-width:480px)">
              .moz-text-html .mj-column-per-100 {
                width: 100% !important;
                max-width: 100%;
              }
            </style>
            <style type="text/css">
              @media only screen and (max-width:480px) {
                table.mj-full-width-mobile {
                  width: 100% !important;
                }
          
                td.mj-full-width-mobile {
                  width: auto !important;
                }
              }
            </style>
          </head>
          
          <body style="word-spacing:normal;">
            <div style="">
              <!-- Header con logo -->
              <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
              <div style="margin:0px auto;max-width:600px;">
                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
                  <tbody>
                    <tr>
                      <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                        <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                        <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                            <tbody>
                              <tr>
                                <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                                    <tbody>
                                      <tr>
                                        <td style="width:76px;">
                                          <img height="auto" src="https://www.appsaudi.com.mx/resources/images/logo_audi.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="76" />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!--[if mso | IE]></td></tr></table><![endif]-->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
              <!-- Cuerpo Texto -->
              <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
              <div style="margin:0px auto;max-width:600px;">
                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
                  <tbody>
                    <tr>
                      <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                        <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                        <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                            <tbody>
                              <tr>
                                <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                  <div style="font-family:AudiType,sans-serif;font-size:17px;line-height:1;text-align:left;color:#000000;"><strong>Has recibido un nuevo lead digital: "Configurador" </strong></div>
                                </td>
                              </tr>
                              <tr>
                                <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                  <div style="font-family:AudiType,sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#000000;">
                                  Trato: ${tratamiento} <br />
                                  Nombre: ` +
            stateData.nombre +
            ` <br /> Apellido Paterno: ` +
            stateData.apellidoPaterno +
            ` <br /> Ciudad: ` +
            stateData.ciudad +
            ` <br /> Estado: ` +
            stateData.estado +
            ` <br /> Concesionaria: ` +
            stateData.concesionario +
            ` <br /> Comentarios: ` +
            stateData.comentarios +
            ` <br /> Modelo: ` +
            stateData.modelinfo.carline.name +
            ` <br /> Audi Code: ` +
            stateData.ac +
            ` <br /> Versión: ` +
            stateData.modelinfo.model.name +
            ` <br /> Color Exterior: ` +
            stateData.modelinfo.exteriorColor.name +
            ` <br /> Potencia: ` +
            stateData.modelinfo.topSpeed.value +
            stateData.modelinfo.topSpeed.unit +
            ` <br /> Transmisión: ` +
            stateData.modelinfo.transmision.value +
            ` <br /><br /> Permiso Transferencia de Datos: ` +
            permisoTransferenciaDatos +
            ` <br /> Fecha: ` +
            stateData.fecha +
            `</div>
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size:0px;word-break:break-word;">
                                  <div style="height:20px;line-height:20px;">&#8202;</div>
                                </td>
                              </tr>
                              <tr>
                                <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                  <div style="font-family:AudiType,sans-serif;font-size:16px;line-height:1;text-align:left;color:#000000;">Atentamente, <br /> Audi de México</div>
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size:0px;word-break:break-word;">
                                  <div style="height:20px;line-height:20px;">&#8202;</div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!--[if mso | IE]></td></tr></table><![endif]-->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
              <!-- Footer -->
              <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
              <div style="margin:0px auto;max-width:600px;">
                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
                  <tbody>
                    <tr>
                      <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                        <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                        <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                            <tbody>
                              <tr>
                                <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                  <p style="border-top:solid 1px #757575;font-size:1px;margin:0px auto;width:100%;">
                                  </p>
                                  <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 1px #757575;font-size:1px;margin:0px auto;width:550px;" role="presentation" width="550px" ><tr><td style="height:0;line-height:0;"> &nbsp;
          </td></tr></table><![endif]-->
                                </td>
                              </tr>
                              <tr>
                                <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                  <div style="font-family:AudiType,sans-serif;font-size:10px;line-height:1.5;text-align:left;color:#757575;">Este mensaje se envió a <a href='mailto:${process.env.REACT_APP_CORREO_AUDI}' target='_blank' style='color: #000000;text-decoration: none;font-weight: bold;'>
                                  ${process.env.REACT_APP_CORREO_AUDI}
            </a> <br />
                                    <a href='` +
            urlAvisoDePrivacidad +
            `' target='_blank' style='color: #000000;text-decoration: none;border-bottom-color: #000000;border-bottom-width: 1px; border-bottom-style: solid;'>Política de Privacidad</a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!--[if mso | IE]></td></tr></table><![endif]-->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </div>
          </body>
          
          </html>`,
        },
      });
      resolve(respuesta);
    } catch (error) {
      //Si existe un error
      console.log("Error correo: ", error);
      reject("Error en petición a API - Concesionario");
    }
  });
};
